export const ResultTypes = {
  NOTES: 'notes',
  NOTES123: 'notes123',
};
